import React from 'react';
import { Page } from 'components';
import ContractsTable from './ContractsTable';
import ContractsContextProvider from './ContractsContext';

const ContractsPage: React.FC = () => (
    <ContractsContextProvider>
      <Page type="filled" title={'Contracts'} fillScreenHeight>
        <ContractsTable />
      </Page>
    </ContractsContextProvider>
  );

export default ContractsPage;
